
// let env = "online";
// let baseURL = "";
// let erpUrl = ''
// switch (env) {
//     case "huidu":
//         baseURL = "http://huidu.test.crm.api.shixinyuezi.net/api/"
//         erpUrl = "http://huidu.test.shixinyuezi.net"
//     break;
//     case "test":
//         baseURL = "http://test.crm.api.shixinyuezi.net/api/"
//         erpUrl = "http://test.shixinyuezi.net"
//     break;
//     case "dev":
//         baseURL = "http://dev.crm.api.shixinyuezi.net/api/"
//         erpUrl = ""
//     break;
//     case "online":
//         baseURL = "https://crm.api.shixinyuezi.net/api/"
//         erpUrl = "https://erp.shixinyuezi.net"
//     break;
// }

let baseURL = window.g.baseURL
let erpUrl = window.g.erpUrl
// baseURL = "http://huidu.test.crm.api.shixinyuezi.net/api/"
// erpUrl = "http://huidu.test.shixinyuezi.net"
export default{
    erpUrl:erpUrl,
    login : baseURL + 'auth/login',//登录
    agent : baseURL + 'agent/agent',//员工
    agentAll : baseURL + 'agent/agent/all',//所有员工
    role : baseURL + 'agent/role',//角色
    permission : baseURL + 'agent/permission',//权限
    department : baseURL + 'agent/department',//部门
    position : baseURL + 'agent/position',//部门
    storeAll : baseURL + 'agent/store/all',//获取所有公司
    departmentAll : baseURL + 'agent/department/all',//获取所有部门
    positionAll : baseURL + 'agent/position/all',//获取所有职位
    roleAll : baseURL + 'agent/role/all',//获取所有角色
    permissionAll : baseURL + 'agent/permission/all',//所有权限
    crmChannel:baseURL + 'crm/channel',//渠道列表
    crmChannelTagAll:baseURL + 'crm/channel/tag/all',//所有标签
    crmChannelTag:baseURL + 'crm/channel/tag',//标签列表
    crmMemberGroup:baseURL + 'crm/member/group',//所有分组
    crmSchedule:baseURL + 'crm/schedule',//排班列表
    returnWay : baseURL + 'crm/visit/returnWay',//回访列表
    shopWay: baseURL + 'crm/visit/shopWay' ,//到店结果
    returnTaskList:baseURL+'crm/visit/returnTaskList',//回访任务列表
    saveReturnTask:baseURL+'crm/visit/saveReturnTask',//新增修改回访任务
    getReturnTaskDetail:baseURL+'crm/visit/getReturnTaskDetail',//回访任务详情
    shopWay : baseURL + 'crm/visit/shopWay',//到店列表
    getDelayFollow : baseURL + 'crm/visit/getDelayFollow',//延迟跟进
    channelAll : baseURL + "crm/channel/all",//所有渠道
    crmScheduleUpdate:baseURL + 'crm/schedule/update',//设置排班
    crmScheduleWeight:baseURL + 'crm/schedule_weight',//设置排班权重
    crmStoreGetCurrentStore:baseURL + 'crm/schedule/get_current_store',//获取当前门店
    crmScheduleImport:baseURL + 'crm/schedule/import',//导入排班
    crmScheduleExport:baseURL + 'crm/schedule/export',//导出排班
    getAllMemberList : baseURL + 'crm/member/getAllMemberList',//连锁客户列表
    getAllMemberListNew : baseURL + 'crm/member/getAllMemberListNew',//新连锁客户列表
    getMemberList: baseURL + 'crm/member/importMember/getMemberList', //批量导入用户
    batchImport:baseURL + 'crm/member/importMember/import', //批量导入
    getDepartmentList:baseURL + 'crm/member/importMember/departmentList',//连锁客户-获取渠道部门列表
    getChannelList:baseURL + 'crm/member/importMember/channelList', //客资导入-获取渠道
    getMemberGroupList:baseURL+'crm/member/importMember/memberGroupList', //客资导入-获取用户分组
    getImportMemberDetail: baseURL + 'crm/member/importMember/member',//获取客资详细
    memberEdit: baseURL + 'crm/member/importMember/memberEdit',//客资编辑
    memberInput: baseURL + 'crm/member/importMember/memberInput',//客资编辑
    memberDel: baseURL + 'crm/member/importMember/memberDel',//客资编辑
    getStoreMemberList : baseURL + 'crm/member/getStoreMemberList',//客户管理列表
    getStoreMemberListNew : baseURL + 'crm/member/getStoreMemberListNew',//客户管理列表
    getMemberDetail : baseURL + 'crm/member/getMemberDetail',//我的客户列表详情
    getMemberGroupList : baseURL + 'crm/member/importMember/memberGroupList',//用户分组
    province : baseURL + 'crm/member/getProvinceList',//省
    city : baseURL + 'crm/member/getCityList',//市
    delMaternalFamily : baseURL + 'crm/member/delMaternalFamily',//删除家属
    getReturnSettingList : baseURL + 'crm/member/getReturnSettingList',//到店方式1，回访方式2
    addMember : baseURL + 'crm/member/saveMember',//添加客户
    watchPhone : baseURL + 'crm/member/getClientPhoneExist',//监听客户手机号
    addChannel : baseURL + 'crm/member/saveChannelInfo',//添加渠道
    addVisit :baseURL + 'crm/visit/visit',//添加回访记录
    editMember :baseURL + 'crm/member/editMember',//修改客户信息
    editMemberFamily :baseURL + 'crm/member/saveMaternalOrFamily',//修改客户家属信息
    batchAbandonFollowUser :baseURL + 'crm/member/batchAbandonFollowUser',//批量放弃跟进人
    crmGetMemberVisits : baseURL + 'crm/visit/myMember/getMemberVisits',//获取回访记录
    crmMemberEditMember : baseURL + 'crm/member/editMember',//修改用户信息
    crmMemberSaveFollowStore : baseURL + 'crm/member/saveFollowStore',//修改跟进门店
    crmMemberSaveMaternalOrFamily : baseURL + 'crm/member/saveMaternalOrFamily',//修改产妇信息
    crmMemberSaveAgainFollowStatus: baseURL + 'crm/member/saveAgainFollowStatus',//重新跟进
    crmMemberDelFollowUser: baseURL + 'crm/member/delFollowUser',//删除跟进
    crmMemberSaveFollowAgent: baseURL + 'crm/member/saveFollowAgent',// 添加跟进人
    crmMemberBatchAllotFollowUser : baseURL + 'crm/member/batchAllotFollowUser',//批量分配跟进人
    crmMemberBatchDelFollowUser: baseURL + 'crm/member/batchDelFollowUser',//批量删除跟进人
    getMemberVipList : baseURL + 'crm/member/getMemberVipList',//会员管理列表
    myMemberExport : baseURL + 'crm/member/my_member_export',//我的客户导出
    vipMemberExport : baseURL + 'crm/member/vip_member_export',//会员管理导出
    myMemberVisitExport : baseURL + 'crm/member/my_member_visit_export',//我的客户回访记录导出
    vipMemberVisitExport : baseURL + 'crm/member/vip_member_visit_export',// 会员管理回访记录导出
    allMemberExport: baseURL + 'crm/member/all_member_export',//连锁客户导出
    storeMemberExport:baseURL + 'crm/member/store_member_export',// 客户管理导出
    allMemberVisitExport:baseURL + 'crm/member/all_member_visit_export',// 连锁客户回访记录导出
    storeMemberVisitExport:baseURL + 'crm/member/store_member_visit_export',//客户管理回访记录导出
    getMyMemberList:baseURL + 'crm/member/getMyMemberList',//我的客户
    getMyMemberListNew:baseURL + 'crm/member/getMyMemberListNew',//我的客户
    getMemberInfo:baseURL + 'crm/visit/getMemberInfo',//添加回访时输入框用户信息回显
    isDelFollowAgentAuth:baseURL + 'crm/member/delOrEditFollowAgent ',//跟进人权限
    isCanHandleMemberStoreGroupAuth:baseURL + 'crm/member/delOrEditFollowStoreGroup',//跟进门店权限
    exportDelayFollow:baseURL + 'crm/visit/exportDelayFollow',//延误跟进导出客户
    crmToErpMember:baseURL + 'erp/crmToErpMember/',//同步客户数据
    getRecommendQrCode:baseURL + 'recommend_member/getRecommendQrCode',//获取填写客资二维码
    addChannelQrCodeStore:baseURL + 'crm/channel/addChannelQrCodeStore',//添加渠道二维码允许开放的门店
    getChannelQrCodeStore:baseURL + 'crm/channel/getChannelQrCodeStore',//获取渠道二维码允许开放的门店表
    getCustomerPhoneInfo:baseURL + 'crm/member/getCustomerPhoneInfo',//获取关联客户手机号
    addRelineshipsCustome:baseURL + 'crm/member/addRelineshipsCustomer',//添加关联用户
    agentPosition:baseURL + 'agent/agent/position',//员工列表-职位选择
    agentDepartment:baseURL + 'agent/agent/department',//员工列表-部门选择
    agentRole:baseURL + 'agent/agent/role',//员工列表-角色选择
    positionDepartment:baseURL + 'agent/position/department',// 职位列表-部门选择
    departmentStore:baseURL + 'agent/department/store',//部门列表-开放门店
    visitStore:baseURL + 'crm/visit/store',//延误跟进记录-门店选择
    visitDepartmentChannel:baseURL + 'crm/visit/channel/store',//延误跟进记录-渠道-部门选择
    visitChannel:baseURL + 'crm/visit/channel',//延误跟进记录-渠道选择
    visitDepartmentFollow:baseURL + 'crm/visit/agent/store',//延误跟进记录-跟进人-部门选择
    visitAgent:baseURL + 'crm/visit/agent',//延误跟进记录-跟进人选择
    crmChannelStore:baseURL + 'crm/channel/store',//渠道列表-门店选择
    crmChannelDepartment:baseURL + 'crm/channel/department',//渠道列表-部门选择
    crmScheduleStore:baseURL + 'crm/schedule/store',//母婴顾问排版列表-门店选择
    crmChildbirthHospital:baseURL+'external/getAddressList',//分娩医院检索
    // 我的客户
    myMemberSaveMember:baseURL + 'crm/member/myMember/saveMember',//我的客户-新增客户
    myMemberGetProvinceList:baseURL + 'external/getProvinceList',//我的客户-获取省份列表
    myMemberGetCityList:baseURL + 'external/getCityList',//我的客户-获取城市列表
    myMemberGetMemberDetail:baseURL + 'crm/member/myMember/getMemberDetail',//我的客户-客户信息详情
    myMemberBatchAbandonFollowUser:baseURL + 'crm/member/batchAbandonFollowUser',//批量放弃跟进人
    myMemberEditMember:baseURL + 'crm/member/myMember/editMember',//我的客户-编辑用户信息
    myMemberGetClientPhoneExist:baseURL +'crm/member/myMember/getClientPhoneExist',//我的客户-判断手机号账号是否系统中的提示
    myMemberDepartmentAll:baseURL +'agent/myMember/department/all',//我的客户-获取渠道部门列表
    myMemberStoreAll:baseURL +'agent/myMember/store/all',//我的客户-获取门店列表
    myMemberChannelAll:baseURL +'crm/channel/myMember/all',//我的客户-根据部门id获取对应的渠道列表
    myMemberGroupAll:baseURL +'crm/member/myMember/group/all',//我的客户-获取客户门店分组
    myMemberAgentAll:baseURL +'agent/myMember/agent/all',//我的客户-根据部门id和门店id获取对应的员工列表
    myMemberDelOrEditFollowStoreGroup:baseURL +'crm/member/myMember/delOrEditFollowStoreGroup',// 我的客户-创建二次意向-伪删除跟编辑跟进门门店的权限
    myMemberDelOrEditFollowAgent:baseURL +'crm/member/myMember/delOrEditFollowAgent',//我的客户-创建二次意向-伪删除跟编辑跟进门人的权限
    myMemberSaveChannelInfo:baseURL +'crm/member/myMember/saveChannelInfo',//我的客户-保存渠道
    myMemberGetMemberVisits:baseURL +'crm/visit/myMember/getMemberVisits',//我的客户-回访记录
    myMemberSaveMaternalOrFamily:baseURL +'crm/member/myMember/saveMaternalOrFamily',//我的客户-保存产妇或家属信息
    myMemberAddMemberBtn:baseURL +'crm/member/myMember/addMemberBtn',//我的客户-是否有新增客户页面的按钮权限
    myMemberShopWay:baseURL +'crm/visit/myMember/shopWay',//我的客户-到店方式列表
    myMemberReturnWay:baseURL +'crm/visit/myMember/returnWay',//我的客户-回访方式列表
    myMemberAbandonFollowUser:baseURL +'crm/member/abandonFollowUser',//我的客户-放弃跟进人
    myMemberSaveMemberAndCreateOrder:baseURL +'crm/member/myMember/saveMemberAndCreateOrder',// 我的客户-新增客户并创建预定单
    myMembergetMemberReturnTaskList:baseURL+'crm/visit/getMemberReturnTaskList',//我的客户-用户未完成任务
    myMembergetMyMemberStatusReturnTaskCount:baseURL+'crm/member/myMember/getMyMemberStatusReturnTaskCount',//我的客户-统计任务条数
    myMembergetEditMemberPhone:baseURL+'crm/member/myMember/editMemberPhone',//我的客户-客户详情-是否有修改手机号的权限
    
    // 共同方法
    copyMemberPhone:baseURL + 'crm/member/copyMemberPhone', //复制手机号
    getMemberPhone:baseURL + 'crm/member/getMemberPhone',   //获取手机号

    // 客户管理
    storeMemberStoreAll:baseURL+'agent/storeMember/store/all',//客户管理-获取门店列表
    storeMemberGroupAll:baseURL+'crm/member/storeMember/group/all',//客户管理-获取客户门店分组
    memberSaveMember:baseURL + 'crm/member/storeMember/saveMember',//客户管理-新增客户
    memberBatchAllotFollowUser:baseURL + 'crm/member/storeMember/batchAllotFollowUser',//客户管理-批量分配跟进人
    memberGetMemberDetail:baseURL + 'crm/member/storeMember/getMemberDetail',// 客户管理-客户信息详情
    memberGetCityList:baseURL + 'external/getCityList',//客户管理-获取城市列表
    memberBatchDelFollowUser:baseURL + 'crm/member/batchDelFollowUser',//客户管理-批量删除跟进人
    memberGetProvinceList:baseURL + 'external/getProvinceList',//客户管理-获取省份列表
    memberEditMember:baseURL + 'crm/member/storeMember/editMember',//客户管理-编辑用户信息
    memberSaveMaternalOrFamily:baseURL + 'crm/member/storeMember/saveMaternalOrFamily',//客户管理-保存产妇或家属信息
    memberSaveChannelInfo:baseURL + 'crm/member/storeMember/saveChannelInfo',//客户管理-保存渠道
    memberSaveFollowStore:baseURL + 'crm/member/storeMember/saveFollowStore',//客户管理-客户管理保存跟进门店信息
    memberSaveFollowAgent:baseURL + 'crm/member/storeMember/saveFollowAgent',//客户管理-保存跟进人信息
    memberSaveAgainFollowStatus:baseURL + 'crm/member/storeMember/saveAgainFollowStatus',//客户管理-重新跟进操作
    memberGetClientPhoneExist:baseURL + 'crm/member/storeMember/getClientPhoneExist',//客户管理-判断手机号账号是否系统中的提示
    memberDelFollowUser:baseURL + 'crm/member/storeMember/delFollowUser',//客户管理-删除跟进人操作
    memberDelOrEditFollowStoreGroup:baseURL + 'crm/member/storeMember/delOrEditFollowStoreGroup',//客户管理-伪删除跟编辑跟进门门店的权限
    memberDelOrEditFollowAgent:baseURL + 'crm/member/storeMember/delOrEditFollowAgent',//客户管理-伪删除跟编辑跟进门人的权限
    memberDepartmentAll:baseURL + 'agent/storeMember/department/all',//客户管理-获取渠道部门列表
    memberStoreMemberAll:baseURL + 'crm/channel/storeMember/all',//连锁客户-根据部门id获取对应的渠道列表memberChannelAll
    memberStoreMemberAgentAll:baseURL + 'agent/storeMember/agent/all',//客户管理-根据部门id和门店id获取对应的员工列表
    memberGetMemberVisits:baseURL +'crm/visit/storeMember/getMemberVisits',//客户管理-回访记录
    memberAddMemberBtn:baseURL +'crm/member/storeMember/addMemberBtn',//客户管理-是否有新增客户页面的按钮权限
    memberShopWay:baseURL +'crm/visit/storeMember/shopWay',//客户管理-到店方式列表
    memberSaveMemberAndCreateOrder:baseURL +'crm/member/storeMember/saveMemberAndCreateOrder',//客户管理-新增客户并创建预定单
    memberEditMemberPhone:baseURL +'crm/member/storeMember/editMemberPhone',//客户管理-客户详情-是否有修改手机号的权限
    // memberphoneExist:baseURL +'external/getClientPhoneExist',

    arrivalLog:baseURL +'crm/member/arrivalLog/index', //到店结果列表
    arrivalExport: baseURL +'crm/member/arrivalLog/export', //到店结果导出
    arrivalStore:baseURL +'crm/member/store',//到店结果获取门店
    arrivalDepartment:baseURL +'crm/member/department',//到店结果获取门店部门
    arrivalAgent:baseURL +'crm/member/agent',//到店结果获取门店部门员工
    arrivalResultList: baseURL + 'external/ArrivalResultConfig/list',
    arrival_result_index: baseURL + 'crm/visit/ArrivalResultConfig/index', //列表
    arrival_result_update: baseURL + 'crm/visit/ArrivalResultConfig/update', //列表
    arrival_result_add: baseURL + 'crm/visit/ArrivalResultConfig/add',   //添加
    arrival_result_edit: baseURL + 'crm/visit/ArrivalResultConfig/detailed', //详情
    arrival_result_show: baseURL + 'crm/visit/ArrivalResultConfig/show', //详情
    arrival_result_del: baseURL + 'crm/visit/ArrivalResultConfig/delete', //删除

    

    //连锁客户
    allMemberStoreAll:baseURL+'agent/allMember/store/all',//连锁客户-获取门店列表
    allMemberGroupAll:baseURL+'crm/member/allMember/group/all',//连锁客户-获取客户门店分组
    allMemberGetProvinceList:baseURL+'external/getProvinceList',//连锁客户-获取省份列表
    allMemberGetCityList:baseURL+'external/getCityList',//连锁客户-获取城市列表
    allMemberBatchAllotFollowUser:baseURL + 'crm/member/allMember/batchAllotFollowUser',//连锁客户-批量分配跟进人
    allMemberEditMember:baseURL + 'crm/member/allMember/editMember',//连锁客户-编辑用户信息
    allMemberGetMemberDetail:baseURL + 'crm/member/allMember/getMemberDetail',//连锁客户-用户详情
    allMemberSaveChannelInfo:baseURL + 'crm/member/allMember/saveChannelInfo',//连锁客户-保存渠道
    allMemberSaveFollowStore:baseURL + 'crm/member/allMember/saveFollowStore',//连锁客户-保存跟进门店信息
    allMemberSaveFollowAgent:baseURL + 'crm/member/allMember/saveFollowAgent',//连锁客户-保存跟进人信息
    allMemberSaveAgainFollowStatus:baseURL + 'crm/member/allMember/saveAgainFollowStatus',//连锁客户-重新跟进
    allMemberDelFollowUser:baseURL + 'crm/member/allMember/delFollowUser',//连锁客户-删除跟进人
    allMemberDepartmentAll:baseURL + 'agent/allMember/department/all',//连锁客户-获取渠道部门列表
    allMemberChannelAll:baseURL + 'crm/channel/allMember/all',//连锁客户-根据部门id获取对应的渠道列表
    allMemberAgentAll:baseURL +'agent/allMember/agent/all',//根据部门id和门店id获取对应的员工列表
    allMemberSaveMaternalOrFamily:baseURL +'crm/member/allMember/saveMaternalOrFamily', //连锁客户--保存产妇或家属信息
    allMemberGetMemberVisits:baseURL +'crm/visit/allMember/getMemberVisits',//连锁客户-回访记录
    allMemberShopWay:baseURL +'crm/visit/allMember/shopWay',//连锁客户-到店方式列表
    allMemberEditMemberPhone:baseURL +'crm/member/allMember/editMemberPhone',//连锁客户-客户详情-是否有修改手机号的权限
    allMemberExternalPhoneExist:baseURL +'external/getClientPhoneExist',//连锁客户-监听手机号码
    //会员管理
    vipMemberStore:baseURL +'agent/vipMember/store/all',//会员管理-获取门店列表
    vipMemberDepartment:baseURL +'agent/vipMember/department/all',//会员管理-获取渠道部门列表
    vipMemberAgent:baseURL +'agent/vipMember/agent/all',//会员管理-根据部门id和门店id获取对应的员工列表
    vipMemberChannel:baseURL +'crm/channel/vipMember/all',//会员管理-根据部门id获取对应的渠道列表

    index:baseURL +'crm/index/index',//首页
    indexStore: baseURL + 'crm/index/store', //首页门店
    indexDepartment: baseURL + 'crm/index/department', //首页门店部门
    indexAgent: baseURL + 'crm/index/agent', //首页门店销售
}



// WEBPACK FOOTER //
// ./src/serve/api.js